import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as DoorAccessActionCreators from '../../../actions/doorAccess'
import CommunityGrantDoorAccessDialog from './CommunityGrantDoorAccessDialog'

class CommunityGrantDoorAccessDialogContainer extends React.Component {
  static propTypes = {
    /* passed props */
    communityId: PropTypes.number.isRequired,
    /* mapped state */
    dialogGrantDoorAccessUserIds: PropTypes.array.isRequired,
    doorAccesses: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      dialogGrantDoorAccessUserIds: state.dialogGrantDoorAccessUserIds,
      doorAccesses: state.doorAccesses,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  handleClose = () => {
    this.props.doorAccessActions.clearGrantDoorAccessUserIds()
  }

  handleGrantCommunityAccess = () => {
    this.props.doorAccessActions.addCommunityDoorAccesses(
      this.props.communityId,
      this.props.dialogGrantDoorAccessUserIds,
    )
    this.handleClose()
  }

  handleGrantUnitAccess = (unitIds) => {
    this.props.doorAccessActions.addUnitDoorAccesses(
      unitIds,
      this.props.dialogGrantDoorAccessUserIds,
    )
    this.handleClose()
  }

  getDialogTitle = () => {
    const { dialogGrantDoorAccessUserIds, doorAccesses } = this.props
    let title = 'Grant Door Access to '

    if (dialogGrantDoorAccessUserIds.length === 1) {
      const accessId = dialogGrantDoorAccessUserIds[0]
      title += doorAccesses[accessId].name || accessId
    } else {
      title += `${dialogGrantDoorAccessUserIds.length} Selected Users`
    }

    return title
  }

  render() {
    if (this.props.dialogGrantDoorAccessUserIds.length > 0) {
      return (
        <CommunityGrantDoorAccessDialog
          communityId={this.props.communityId}
          dialogTitle={this.getDialogTitle()}
          onClose={this.handleClose}
          onGrantCommunityAccess={this.handleGrantCommunityAccess}
          onGrantUnitAccess={this.handleGrantUnitAccess}
        />
      )
    }

    return null
  }
}

export default connect(
  CommunityGrantDoorAccessDialogContainer.mapStateToProps,
  CommunityGrantDoorAccessDialogContainer.mapDispatchToProps,
)(CommunityGrantDoorAccessDialogContainer)
